import secureLocalStorage from "react-secure-storage";
import React from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
import { filterBy } from "@progress/kendo-data-query";
export default class RiskTypeDropDownCell extends GridCell {
  state = {
    value: [],
    dropdownListData: [],
  };

  handleChange = (event) => {
    this.setState({
      value: event.target.value,
      viewValue: [],
    });
    // document.getElementById("risktypeId").focus();
  };

  componentDidMount = () => {
    this.initLoad();
  };

  initLoad() {
    try {
      if (
        this.props.dataItem[this.props.field] &&
        this.props.dataItem[this.props.field] != "undefined"
      ) {
        let savedNames = this.props.dataItem[this.props.field];
        let savedIds = savedNames.toString().split(",");
        let ids = [];
        let viewValue = [];
        savedIds.map((id, index) => {
          let value = this.props.dropDownData.find(
            (item) => item.hashValue === id
          );
          ids.push(value);
          // let temp=index==savedIds.length-1?value.text:value.text+","
          viewValue.push(value.text);
        });
        this.setState({
          value: ids,
          viewValue: viewValue.toString(),
          dropdownListData: this.props.dropDownData,
        });
        // document.getElementById("risktypeId").focus();
      } else {
        this.setState({
          dropdownListData: this.props.dropDownData,
        });
      }
    } catch (err) {}
  }

  handleChangeBlur = (e) => {
    let riskTypeIds = [];
    this.state.value.map((item) => {
      riskTypeIds.push(item.text);
    });

    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: riskTypeIds, //this.state.value,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit &&
      this.props.dataItem.riskRegisterId
    ) {
      let updateData = {
        ...this.props.dataItem,
        riskTypeNames: riskTypeIds,
      };
      this.props.updateDropdownValue(updateData);
    }
  };
  handlefilter = (e) => {
    const filteredvalue = filterBy(this.props.dropDownData, e.filter);
    this.setState({
      dropdownListData: filteredvalue,
    });
  };
  handleEditCell = () => {
    if (this.props.dataItem.riskRegisterId) {
      this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  itemRender = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          checked={itemProps.selected}
          onChange={() => {}}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };
  getSortedList = () => {
    let sortedlist = this.state.dropdownListData.sort(function (a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    return sortedlist?.filter((item) => item.name != " [blank]");
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const ownerId = dataItem.userId;
    const value = this.state.value;
    const selected = value.length;

    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <MultiSelect
            id="risktypeId"
            onChange={this.handleChange}
            onBlur={this.handleChangeBlur}
            itemRender={this.itemRender}
            value={value}
            data={this.getSortedList()}
            valueField="value"
            textField="text"
            autoClose={false}
            tags={
              selected > 0
                ? [{ text: `${selected} items selected`, data: [...value] }]
                : []
            }
            filterable={true}
            onFilterChange={(e) => this.handlefilter(e)}
          />
        </td>
      );
    }
    if (this.props.dataItem.inEdit !== this.props.field) {
      if (loginUserId === ownerId) {
        return (
          <td onClick={this.handleEditCell} title={this.state.viewValue}>
            {this.state.viewValue}
          </td>
        );
      } else {
        return this.props.dataItem.role == "Standard User" ||
          this.props.dataItem.role == "View Only" ? (
          <td title={this.state.viewValue}>{this.state.viewValue}</td>
        ) : (
          <td onClick={this.handleEditCell} title={this.state.viewValue}>
            {this.state.viewValue}
          </td>
        );
      }
    }
  }
}
